export default __webpack_public_path__ + "static/header-c1bc8865c958b62972dda24726406629.png";